module.exports = {
  platform: 'voice',
  name: 'Write',
  node: 'write',
  bg: '#FFFFFF',
  note: '',
  property: {
    operation: 'value', // clear, value, prepend, append, increase, decrease, lookup
    field_id: undefined,
    field_name: '',
    fields: undefined,
    fields_name: [],
    value: '',
    searching_key: '',
    lookup_table_id: '',
    lookup_table_name: '',
    column_index: '',
    default_value: ''
  }
}
